import React, { useCallback, useEffect, useState } from 'react';
import { Theme, useMediaQuery } from '@mui/material';
import Image from 'next/legacy/image';
import { useModal } from 'hooks';
import { useSelector } from 'react-redux';
import { DetectMarketSelectors } from 'store/selectors';
import Median from 'median-js-bridge';
import useMedian from 'hooks/useMedian';
import SearchHeaderField from './SearchHeaderField';
import SearchModal from './SearchModal';

const SearchHeader: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));
  const [inputValue, setInputValue] = useState('');
  const [showSearchModal] = useModal(SearchModal);
  const market = useSelector(DetectMarketSelectors.getSelectedMarket);
  const { selectSearchTab, detectTab } = useMedian();

  const handleDialogClose = useCallback(() => {
    if (Median.isNativeApp()) detectTab();
    setInputValue('');
  }, [detectTab]);

  useEffect(() => {
    window.onSearchEventsClick = () => {
      if (Median.isNativeApp()) selectSearchTab();
      showSearchModal({ search: inputValue, marketSlug: market, onClose: handleDialogClose });
    };
  }, [handleDialogClose, inputValue, market, selectSearchTab, showSearchModal]);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const { value } = event.target;
    setInputValue(value);
    if (value.length > 2) {
      showSearchModal({ search: value, marketSlug: market, onClose: handleDialogClose });
    }
  };

  const handleOnClick = () => {
    if (Median.isNativeApp()) selectSearchTab();
    showSearchModal({ search: inputValue, marketSlug: market, onClose: handleDialogClose });
  };

  return isMobile ? (
    <Image src="/static/img/icon-search.png" alt="icon-search" width={24} height={24} onClick={handleOnClick} />
  ) : (
    <SearchHeaderField inputValue={inputValue} onChange={handleOnChange} />
  );
};

export default SearchHeader;
